import type { GetSelectionRange, ToggleSelectedElementIds } from "./types";

export const getSelectionRange: GetSelectionRange = ({
  positionByElementId,
  fromElementId,
  toElementId,
}) => {
  const fromPosition = positionByElementId.get(fromElementId);
  const toPosition = positionByElementId.get(toElementId);

  if (fromPosition === undefined || toPosition === undefined) {
    return null;
  }

  return {
    startPosition: Math.min(fromPosition, toPosition),
    endPosition: Math.max(fromPosition, toPosition),
  };
};

export const toggleSelectedElementIds: ToggleSelectedElementIds = ({
  previousSelectedElementIds,
  clickedElementId,
  selectionRange,
  elements,
}) => {
  const next = new Set(previousSelectedElementIds);
  const shouldSelect = !previousSelectedElementIds.has(clickedElementId);

  if (selectionRange === null) {
    if (shouldSelect) {
      next.add(clickedElementId);
    } else {
      next.delete(clickedElementId);
    }
    return next;
  }

  // Gmail-style: the clicked tile's new state is applied to the whole span.
  for (
    let position = selectionRange.startPosition;
    position <= selectionRange.endPosition;
    position++
  ) {
    if (shouldSelect) {
      next.add(elements[position].id);
    } else {
      next.delete(elements[position].id);
    }
  }
  return next;
};
